import { useEffect, useState } from "react";
import Button from "../Button/Button";
import "./styles.css";
import { UpdateUserInfoUrl } from "../../constants";
import { InfoCollection } from "./InfoCollection";
import { useConfig } from "../../context/ConfigContext";
import { ThickCheckMarkIcon } from "../icons/ThickCheckMarkIcon";
import { CirclePulseAnimation } from "../animations/CirclePulseAnimation/CirclePulseAnimation";
import { useTranslation } from "react-i18next";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const QuestionsModule = ({
  apiToken,
  fetchAIResults,
  runNextModule,
  onError,
}) => {
  const { t } = useTranslation("questionsModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const [currentStep, setCurrentStep] = useState(0);
  const [fetchResultsComplete, setFetchResultsComplete] = useState(false);
  const [isResultResponseSuccess, setIsResultResponseSuccess] = useState(false);
  const [isSaveDone, setIsSaveDone] = useState(false);
  const { userQuestions, setSelectedAnswers } = useConfig();

  const fetchResults = async () => {
    const resResponse = await fetchAIResults();
    if (resResponse) {
      setIsResultResponseSuccess(true);
    } else {
      setIsResultResponseSuccess(false);
    }
    setFetchResultsComplete(true);
  };

  useEffect(() => {
    fetchResults();
    const timerId = setTimeout(async () => {
      setCurrentStep(1);
    }, 1500);
    return () => clearTimeout(timerId);
  }, []);

  // useEffect(() => {
  //   if (currentStep === 2 && fetchResultsComplete && !isResultResponseSuccess) {
  //     onError();
  //   }
  // }, [currentStep, fetchResultsComplete, isResultResponseSuccess, onError]);

  const saveSelectedInfo = async (userData) => {
    try {
      const res = await fetch(UpdateUserInfoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apiToken,
        },
        body: JSON.stringify(userData),
      });
      if (!res.ok) {
        throw new Error("Unable to send Questionnaire data!");
      }
    } catch (error) {
      console.error("Error saving selected info:", error);
    }
    setIsSaveDone(true);
  };

  return (
    <div className="questions-module">
      {currentStep === 2 &&
      isSaveDone &&
      isResultResponseSuccess &&
      fetchResultsComplete ? (
        <div className="analyze-progress select-4-rows">
          <ThickCheckMarkIcon className="result-ready-animaton" />
          <h4 className="analyze-title-success">
            {t("results-success-title")}
          </h4>
          <p className="analyze-info-success">{t("results-ready")}</p>
        </div>
      ) : (
        <div
          className={`analyze-progress ${currentStep === 0 || currentStep === 2 ? "select-4-rows" : ""}`}
        >
          <CirclePulseAnimation />
          {currentStep !== 1 && (
            <p className="analyze-text-animated">{t("analyzing")}...</p>
          )}
        </div>
      )}

      {currentStep === 1 && (
        <InfoCollection
          questionsData={userQuestions}
          onComplete={(data) => {
            setSelectedAnswers(data);
            setCurrentStep(2);
            saveSelectedInfo(data);
          }}
        />
      )}
      {currentStep === 2 &&
        isSaveDone &&
        isResultResponseSuccess &&
        fetchResultsComplete && (
          <div className="question-module-btn-wrapper-bottom">
            <Button
              text={t("continue")}
              onClick={() => {
                trackEvent("webapp_user_press_show_results", uid);
                runNextModule();
              }}
            />
          </div>
        )}
    </div>
  );
};
